export const customStyles = {
  headCells: {
    style: {
      color: '#003353',
      fontSize: 16,
      fontWeight: '500',
      lineHeight: 24,
      padding: 0,
      paddingBottom: 12,
      marginTop: 40,
      marginRight: 10,
      maxWidth: 50,
      width: 50,
    },
  },
  cells: {
    style: {
      color: '#003353',
      fontSize: 16,
      paddingTop: 16,
      paddingBottom: 16,
      paddingLeft: 0,
      marginRight: 0,
    },
    header: {
      style: { paddingLeft: 0 },
    },
  },
}
